module.exports = __webpack_public_path__ + "img/icon-scan-pay.97d8e2a1.svg";